module.exports = __webpack_public_path__ + "img/contactUs.bb74540b.jpg";